// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"354":"09a7cfa4ca69e5316d36","379":"4a08f1f9769587f97e4c","693":"f2d1efee5a13a8f8cf15","785":"66e32b897e5c5f3666e1"}[chunkId] + ".chunk.js";
};